import { makeLoadHook } from '../../common';
import { loadSkills } from '../networks';

export const useLoadSkills = makeLoadHook(loadSkills);
